import plus from './plus.svg'

export const LogoPlus = () => <img src={plus} alt="Plus logo" />
